function LovrException(message, e_type) {
    this.message = message
    this.type = e_type
  }
  
  export default LovrException;